import { folders } from "@/widgets/explorer/config/folders";
import { reports } from "@/widgets/explorer/config/reports";

export default {
  folders,
  reports,
};
